import styled from '@emotion/styled';
import { ContentWrapper, fontSize } from '@styles/globalStyles';
import { breakpoint } from '@styles/breakpoints';

export const Container = styled.section`
  background-color: #f7f7f8;
  padding: 72px 0 120px 0;

  h2 {
    margin-bottom: 56px;
    font-weight: 400;
  }

  @media only screen and ${breakpoint.lg} {
    padding: 32px 0;

    h1 {
      margin-bottom: 20px;
      font-size: ${fontSize(24)};
      font-weight: bold;
    }
  } ;
`;

export const Wrapper = styled(ContentWrapper)`
  @media only screen and (max-width: 1350px) {
    padding: 0 15px;
  } ;
`;

export const TemporaryImage = styled.div`
  width: 100%;
  height: 550px;
  background-color: #212121;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: fit-content;
  text-align: center;
  img {
    width: 100%;
  }
`;
